module.exports = __webpack_public_path__ + "static/img/ic_file.fb7b14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_file.png
// module id = iURf
// module chunks = 1